module.exports = __webpack_public_path__ + "imgs/top-gradient.06bfaeb77d8199b2f8f924458b49d7b4.svg";